// outline blue button

import React from "react";

export default function OutlineSubBtn({ children, onClick, className }) {
  return (
    <button className={`outline-sub-btn py-3 ${className || ""}`} onClick={onClick}>
      {children}
    </button>
  );
}
